
export default function Clients() {
  return (
    <section id="clientes" className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-block bg-amber-500/20 text-amber-400 px-4 py-2 rounded-full text-sm font-semibold mb-6 uppercase tracking-wider">
              Nossos Clientes
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Confiança Construída ao Longo de uma Década
            </h2>
            <p className="text-xl text-gray-300 mb-6 leading-relaxed">
              Ao longo de mais de uma década de atuação, a Gleimatus já atendeu centenas de famílias e investidores que acreditaram em seu compromisso com a entrega e a valorização do patrimônio.
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Seja em residências, edifícios multifamiliares ou empreendimentos comerciais, a confiança de nossos clientes é o maior ativo da marca.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-4xl font-bold text-amber-400 mb-2">500+</div>
                <div className="text-gray-300 text-sm">Famílias Atendidas</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-4xl font-bold text-amber-400 mb-2">98%</div>
                <div className="text-gray-300 text-sm">Satisfação dos Clientes</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/ab80153f2e4d023bd9b61f0053fbbf1d.jpg"
                alt="Clientes Satisfeitos"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl -z-10 opacity-50"></div>
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="flex gap-1 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-300 mb-6 italic leading-relaxed">
              "Profissionalismo e qualidade em cada detalhe. A Gleimatus transformou nosso sonho em realidade."
            </p>
            <div className="font-semibold text-white">Maria Silva</div>
            <div className="text-sm text-gray-400">Proprietária - Ed. Residencial</div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="flex gap-1 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-300 mb-6 italic leading-relaxed">
              "Investimento seguro e rentável. Recomendo a Gleimatus para quem busca seriedade e retorno."
            </p>
            <div className="font-semibold text-white">João Santos</div>
            <div className="text-sm text-gray-400">Investidor</div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
            <div className="flex gap-1 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-amber-400 text-xl"></i>
              ))}
            </div>
            <p className="text-gray-300 mb-6 italic leading-relaxed">
              "Pontualidade na entrega e acabamento impecável. Superou nossas expectativas!"
            </p>
            <div className="font-semibold text-white">Ana Paula Costa</div>
            <div className="text-sm text-gray-400">Moradora</div>
          </div>
        </div>
      </div>
    </section>
  );
}
